import React, { useState, useEffect } from 'react';
import './LoginModal.css';
import { useUser } from '../context/UserContext';

function LoginModal({ isOpen, onClose }) {
  const { login, cookieConsent} = useUser();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');

  // 👇 Blocca il rendering se il modal è chiuso o non c'è il consenso
if (!isOpen || !cookieConsent) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const result = await login(email, password, remember);

    if (result.success) {
      onClose();
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            Ricordami
            <input style={{ width: '10%' }}
              type="checkbox"
              checked={remember}
              onChange={e => setRemember(e.target.checked)}
            />
          </label>

          <button type="submit">Accedi</button>
          {error && <p className="error-msg">{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default LoginModal;
